import {
    Component,
    Input,
    Output,
    Inject,
    Host,
    forwardRef,
    ViewEncapsulation,
    EventEmitter
} from '@angular/core';
import { SmCheckboxGroupComponent } from './sm-checkbox-group.component';
import { SelectValueAccessor } from '../forms';

@Component({
    selector: 'sm-checkbox-item',
    template: `
<div class="form-check"
     [class.disabled]="isDisabled()"
     [class.readonly]="isReadonly()" >
	<label class="form-check-label" >
		<input class="form-check-input"
                (click)="onClick($event)"
	            (change)="toggleCheck($event)"
				type="checkbox"
				[name]="name"
				[checked]="isChecked()"
                [readonly]="isReadonly()"
                [hidden]="checkboxHidden"
				[disabled]="isDisabled()"/>
        <ng-content></ng-content>
		<span *ngIf="label">{{label}}</span>
	</label>
</div>`,
    encapsulation: ViewEncapsulation.None
})
export class SmCheckboxItemComponent {
    @Input() value: any;
    @Input() disabled: boolean = false;
    @Input() readonly: boolean = false;
    @Input() checkboxHidden: boolean = false;
    @Input() name: string = '';
    @Input() label: string = '';
    @Output() onSelect = new EventEmitter<{ event: Event }>();

    constructor(
        @Host()
        @Inject(forwardRef(() => SmCheckboxGroupComponent))
        private checkboxGroup: SmCheckboxGroupComponent
    ) { }

    onClick(event: Event) {
        if (this.isReadonly() || this.isDisabled()) {
            event.preventDefault();
        }
    }

    toggleCheck(event: MouseEvent) {
        if (this.isReadonly() || this.isDisabled()) {
            event.preventDefault();
            return;
        }

        if (this.checkboxGroup.customToggleLogic) {
            this.checkboxGroup.customToggleLogic({
                event: event,
                valueAccessor: this.checkboxGroup.valueAccessor,
                value: this.value
            });
        } else if (this.checkboxGroup.flag) {
            this.bitToggleLogic(this.value);
        } else {
            this.checkboxGroup.valueAccessor.addOrRemove(this.value);
        }

        this.onSelect.emit({ event: event });
    }

    isChecked() {
        if (this.checkboxGroup.customIsSelectedLogic) {
            return this.checkboxGroup.customIsSelectedLogic({
                valueAccessor: this.checkboxGroup.valueAccessor,
                value: this.value
            });
        }

        if (this.checkboxGroup.flag) {
            return this.bitIsSelectedLogic(this.value);
        }

        return this.checkboxGroup.valueAccessor.has(this.value);
    }

    isDisabled() {
        return this.disabled == true || this.checkboxGroup.disabled;
    }

    isReadonly() {
        return this.readonly || this.checkboxGroup.readonly;
    }

    private bitToggleLogic(value: any) {
        this.checkboxGroup.valueAccessor.set(this.checkboxGroup.valueAccessor.model ^ value);
    }

    private bitIsSelectedLogic(value: any): boolean {
        return (this.checkboxGroup.valueAccessor.model & value) == value;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/components/sm-checkbox-item.component.ts